





























































































































































































































































































































































































































































































































































































































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { ReportPlanCashTableData } from "../table-data/table-data-types"
import { Indicator } from "../../../common/types/Indicator"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { ReportPlanCashFilterSettingsForm } from "../settings-form/ReportPlanCashFilterSettingsForm";
import { Segmentation } from "../../../common/types/roots/fields"
import { Classificator } from "../../../common/types/Classificator"
import { ReportPlanCashTemplate4Dspk, ReportPlanCashTemplate4Msu, ReportPlanCashTemplate4Raion } from "../ReportPlanCashResponse"
import { ReportPlanCashRow } from "../Row"

type Column = 'action' | 'kat' | 'cls' | 'pcl' | 'spf' | 'region_name' | 'total_sum' | 'period_sum' | 'sumrg' | 'deviation_period' | 'percent_to_period' | 'deviation_annual' | 'percent_to_year' | 'sumrg_past' | 'deviation_past' | 'growth'

export interface TableField {
    key: Column,
    label: string,
    active: boolean
}

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class ReportPlanCash extends Vue {

    @Prop({
        type: Object,
        required: true,
    })
    public tableData!: ReportPlanCashTableData

    @Prop({
        type: Array,
        required: true
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly PlanCashs!: Classificator[]
    

    @Prop({
        type: Date,
        required: true
    })
    private readonly reportDate!: Date
    private readonly nextYear: number = this.reportDate.getFullYear()


    @Prop({
        type: Array,
        required: true,
    })
    public regions!: object

    @Prop({
        type: Object,
        required: true,
    })
    public filterSettings!: ReportPlanCashFilterSettingsForm

    // Старые indicators (временно оставляем для совместимости)
    public template4Indicators: Column[] = ['total_sum', 'period_sum', 'sumrg', 'percent_to_period']

    // Новая структура: Периоды (год, кварталы, месяцы)
    public template4Periods: string[] = [
        'year',           // Всего на год
        'q1_total',       // 1 квартал всего
        'm1', 'm2', 'm3', // Январь, Февраль, Март
        'q2_total',       // 2 квартал всего
        'm4', 'm5', 'm6', // Апрель, Май, Июнь
        'q3_total',       // 3 квартал всего
        'm7', 'm8', 'm9', // Июль, Август, Сентябрь
        'q4_total',       // 4 квартал всего
        'm10', 'm11', 'm12' // Октябрь, Ноябрь, Декабрь
    ]

    public template4TotalRows = this.tableData.template4_items_structured_dspk?.length ?? 0
    public template4PerPage = 100  // Показываем все КБК (большое число для отображения всех)

    public template4CurrentPage = 1
    // Показываем ВСЕ КБК сразу (древовидная структура)
    public template4CurrentDspk: ReportPlanCashTemplate4Dspk[] = this.tableData.template4_items_structured_dspk ?? []
    // Фильтруем регионы: исключаем записи "Регион XXXXX" (технические записи)
    // Показываем: Актогайский район, Далматовский район и т.д.
    // Не показываем: "Регион 450101", "Регион 320203" и т.п.
    public template4StructuredRegions: (ReportPlanCashTemplate4Raion | ReportPlanCashTemplate4Msu)[] =
        (this.tableData.template4_items_structured_regions ?? []).filter(region => {
            // Исключаем регионы с названием "Регион XXXXX"
            if (region.name.startsWith('Регион ')) {
                return false
            }
            // Если у региона есть дети, фильтруем их тоже
            if ('childs' in region && region.childs) {
                region.childs = region.childs.filter(child => !child.name.startsWith('Регион '))
            }
            return true
        })

    // Переключатель План/Касса
    public selectedDataType: 'plan' | 'cash' = 'plan'
    public dataTypeOptions = [
        { text: 'План', value: 'plan' },
        { text: 'Касса', value: 'cash' }
    ]

    public handlePageChange(page: number) {
        // Теперь показываем все КБК сразу, пагинация не нужна
        // Оставляем метод для совместимости
        this.template4CurrentDspk = this.tableData.template4_items_structured_dspk ?? []
    }

    public activePlanCashs: string[] = this.PlanCashs.filter(it => it.active).map(it => it.key)

    // public variant: 'UNFULFILLED' | 'OVERFULFILLED' = 'UNFULFILLED'
    public tableFields: TableField[] = []
    public indicators: Indicator[] = []

    public columnsNameMap: Record<Column, string> = {
        'action': '',
        'kat': '',
        'cls': '',
        'pcl': '',
        'spf': '',
        'region_name': 'Наименование',
        'total_sum': `План на ${this.nextYear} год`,
        'period_sum': 'План на отчетный период',
        'sumrg': 'Фактическое исполнение',
        'deviation_period': 'Отклонение к периоду',
        'percent_to_period': '% к периоду',
        'deviation_annual': 'Отклонение к годовому плану',
        'percent_to_year': '% к году',
        'sumrg_past': 'Фактическое поступление на аналогичный период прошлого года',
        'deviation_past': 'Темп роста, %',
        'growth': 'Отклонение',
    }
    public totalExpand: boolean = true

    private open = false;

    private treeData: any = [];

    private keyCounter = 0;

    private settings: ReportPlanCashFilterSettingsForm = this.filterSettings;

    private itemsData: ReportPlanCashTableData  = this.tableData;

    private regionsList: any = [];

    // Фиксированная разрезность для этого отчета: КБК -> Регионы
    private segmentations: Segmentation[] = ['KBK', 'REGION']

    private created() {
        this.keyCounter += 1;
        this.indicators = cloneDeep(this.propIndicators);
        this.settings = cloneDeep(this.filterSettings);
        this.itemsData = cloneDeep(this.tableData);
        this.regionsList = cloneDeep(this.regions);
        this.constructTableFields();
        this.treeStructure();
        this.handlePageChange(1)
        this.initializeKbkExpanded()

        // this.$watch(
        //     () => this.filterSettings,
        //     () => {
        //         this.constructTableFields();
        //         this.treeStructure();
        //         this.keyCounter += 1;
        //     },
        //     { deep: true }
        // );
        
    }

    private get filteredTemplate4CurrentDspk(): ReportPlanCashTemplate4Dspk[] {
    // ДОБАВЬТЕ ПРОВЕРКУ ЗДЕСЬ
    if (!this.tableData?.plan_cash_monthly_data) {
        return this.template4CurrentDspk
    }
    
    return this.template4CurrentDspk.filter(dspk_item => {
        // Проверяем есть ли хотя бы один регион с данными для выбранного типа
        const dspkData = this.tableData.plan_cash_monthly_data?.[dspk_item.code] // ДОБАВЬТЕ ?. здесь
        if (!dspkData) return false
        
        for (const regionCode in dspkData) {
            // Пропускаем служебные строки
            if (regionCode.startsWith('total') || regionCode.startsWith('actually')) {
                continue
            }
            
            const monthlyData = dspkData[regionCode]
            const monthsData = this.selectedDataType === 'plan' 
                ? monthlyData.months_plan 
                : monthlyData.months_cash
            
            const total = monthsData?.reduce((sum: number, val: number) => sum + val, 0) || 0
            
            if (total !== 0) {
                return true // Есть хотя бы один регион с данными
            }
        }
        
        return false // Нет ни одного региона с данными для этого КБК
    })
}

    private treeStructure() {
        this.treeData = [];
        if (this.segmentations.length === 1 && this.segmentations[0] === 'REGION') {
            const tree = [];
            for (const data of this.itemsData.template1_items as any) {
                if (data.children) {
                    const { chidlren, ...reg } = data;
                    reg.visible = true;
                    if (data.children.length > 0) {
                        reg.open = this.open;
                    }
                    tree.push(reg);
                    for (const child_reg of data.children) {
                        tree.push(child_reg)
                    }
                } else {
                    data.visible = true;
                    tree.push(data)
                }
            }
            this.treeData = tree;
        }
    }

    private constructTableFields() {
        const tempTableFields: TableField[]  = []

        // Показатели
        this.propIndicators.forEach(indicator => {
            const key: Column = indicator.key as unknown as Column
            if (indicator.key == 'action' || indicator.key == 'kat' || indicator.key == 'cls' || indicator.key == 'pcl' || indicator.key == 'spf') {
                indicator.active = false;
            }
            if (indicator.key == 'sumrg_past' || indicator.key == 'deviation_past' || indicator.key == 'growth') {
                indicator.active = false;
            }

            if (this.segmentations.length === 2) {
                if (['kat', 'cls', 'pcl', 'spf'].includes(key)) {
                    indicator.active = this.activePlanCashs.includes(key)
                }
            }
            tempTableFields.push({ key: key, label: this.columnsNameMap[key], active: indicator.active })
        })

        this.tableFields = tempTableFields
    }

    public formatDigitsGrouping = formatDigitsGrouping

    private openAll() {
        if (this.segmentations.length === 2 && this.segmentations[0] === 'REGION' && this.segmentations[1] === 'KBK' && this.itemsData.template3_items) {
            this.totalExpand = !this.totalExpand
            this.itemsData.template3_items?.forEach(i => {
                i.is_expanded = this.totalExpand
                if (i.level > 0) {
                    i.visible = this.totalExpand
                }
            })
        } else {
            this.open = !this.open;
            for (const r of this.treeData) {
                if (this.segmentations.length === 1 && this.segmentations[0] === 'REGION') {
                    if (r.open !== undefined) {
                        r.open = this.open;
                    } else {
                        r.visible = this.open;
                    }
                }
            }
        }
    }
    
    private openChilds(item: any) {
        item.open = !item.open;
        if (item.kat) {
            if (!item.open) {
                for (const r of this.treeData.filter((x: any) => x.parent_kat == item.kat)) {
                    r.open = item.open;
                    r.visible = item.open;
                }
            } else {
                for (const r of this.treeData.filter((x: any) => x.cls && x.parent_kat == item.kat)) {
                    r.visible = item.open;
                }
            }
        }
        if (item.cls) {
            if (!item.open) {
                for (const r of this.treeData.filter((x: any) => (x.parent_kat == item.parent_kat) && (x.parent_cls == item.cls))) {
                    r.open = item.open;
                    r.visible = item.open;
                }
            } else {
                for (const r of this.treeData.filter((x: any) => x.pcl && (x.parent_cls == item.cls) && (item.parent_kat == x.parent_kat))) {
                    r.visible = item.open;
                }
            }
        }
        if (item.pcl) {
            for (const r of this.treeData.filter((x: any) => x.spf && (x.parent_pcl == item.pcl) && (x.parent_cls == item.parent_cls) && (x.parent_kat == item.parent_kat))) {
                r.visible = item.open;
            }
        }
        if (item.children) {
            for (const r of this.treeData.filter((x: any) => !x.children && x.region_code.slice(0, 4) === item.region_code.slice(0, 4))) {
                r.visible = item.open;
            }
        }
    }

    private valueRound(value: any) {
        if (this.settings.roundUp) {
            const roundUpFactor = Math.pow(10, Number(this.settings.roundUpTo));
            if (Number(this.settings.roundUpTo) > 0) {
                return formatDigitsGrouping(Math.round(value * roundUpFactor) / roundUpFactor);
            }
            return formatDigitsGrouping(Math.round(value));
        }
        // По умолчанию округляем до 2 знаков после запятой (избегаем погрешности floating point)
        const rounded = Math.round(value * 100) / 100
        return formatDigitsGrouping(rounded)
    }

    private openChildsTemplate3(parent_index: number, childs_count: number) {
         if (this.segmentations.length === 2 && this.segmentations[0] === 'REGION' && this.segmentations[1] === 'KBK' && this.itemsData.template3_items) {
            if (parent_index < 0 || parent_index >= this.itemsData.template3_items.length) {
                return;
            }
            const parent = this.itemsData.template3_items[parent_index]
            parent.is_expanded = !parent.is_expanded

            const start = parent_index + 1
            const end = parent_index + childs_count
            const startSafe = Math.max(0, start);
            const endSafe = Math.min(this.itemsData.template3_items.length - 1, end);
            for (let i = startSafe; i <= endSafe; i++) {
                this.itemsData.template3_items[i].visible = parent.is_expanded;
                this.itemsData.template3_items[i].is_expanded = parent.is_expanded;
            }
        }
    }

    private openChildsTemplate4(raion: ReportPlanCashTemplate4Raion) {
        raion.is_childs_visible = !raion.is_childs_visible
    }

    private openChildsTemplate4All() {
        this.totalExpand = !this.totalExpand

        // Разворачиваем/сворачиваем все КБК
        if (this.tableData && this.tableData.template4_items_structured_dspk) {
            this.tableData.template4_items_structured_dspk.forEach(dspk => {
                this.$set(dspk, 'is_expanded', this.totalExpand)
            })
        }

        // Разворачиваем/сворачиваем все регионы
        if (this.tableData && this.tableData.template4_items_structured_regions) {
            this.tableData.template4_items_structured_regions.forEach(region => {
                if ('is_childs_visible' in region) {
                    region.is_childs_visible = this.totalExpand
                }
            })
        }
    }

    private getTemplate4Items(dspk: string, region_code: string, indicator: keyof ReportPlanCashRow) {
        if (this.tableData && this.tableData.template4_items) {
            if (dspk in this.tableData.template4_items && region_code in this.tableData.template4_items[dspk]) {
                return this.valueRound(this.tableData.template4_items[dspk][region_code][indicator])
            }
        }
        return ""
    }

    /**
     * Проверяет, есть ли у региона данные для текущего выбранного типа (План/Касса)
     * На странице "План" показываем регионы где plan != 0
     * На странице "Касса" показываем регионы где cash != 0
     */
    private regionHasDataForSelectedType(dspk: string, regionCode: string): boolean {
        const monthlyData = this.tableData?.plan_cash_monthly_data?.[dspk]?.[regionCode]
        if (!monthlyData) return false

        // Проверяем данные ТОЛЬКО для выбранного типа (План или Касса)
        const monthsData = this.selectedDataType === 'plan'
            ? monthlyData.months_plan
            : monthlyData.months_cash

        if (!monthsData) return false

        // Показываем если есть ненулевые данные для выбранного типа
        const total = monthsData.reduce((sum: number, val: number) => sum + val, 0)
        return total !== 0
    }


    /**
     * Проверяет, есть ли у региона дочерние элементы с данными для текущего типа
     */
    private hasChildrenWithData(dspk: string, region: any): boolean {
        if (!('childs' in region) || !region.childs) return false

        return region.childs.some((child: any) => this.regionHasDataForSelectedType(dspk, child.code))
    }

    private getTemplate4PeriodValue(dspk: string, region_code: string, period: string) {
        // Получаем реальные месячные данные plan/cash
        const monthlyData = this.tableData?.plan_cash_monthly_data?.[dspk]?.[region_code]

        // Используем реальные месячные данные (или массив нулей если данных нет)
        // В зависимости от selectedDataType берем план или кассу
        const monthsData = this.selectedDataType === 'plan'
            ? (monthlyData?.months_plan || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
            : (monthlyData?.months_cash || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

        // Год - сумма всех 12 месяцев
        if (period === 'year') {
            const yearTotal = monthsData.reduce((sum: number, val: number) => sum + val, 0)
            return this.valueRound(yearTotal)
        }

        // Кварталы - сумма 3 месяцев
        if (period === 'q1_total') {
            const q1Total = monthsData[0] + monthsData[1] + monthsData[2]
            return this.valueRound(q1Total)
        }
        if (period === 'q2_total') {
            const q2Total = monthsData[3] + monthsData[4] + monthsData[5]
            return this.valueRound(q2Total)
        }
        if (period === 'q3_total') {
            const q3Total = monthsData[6] + monthsData[7] + monthsData[8]
            return this.valueRound(q3Total)
        }
        if (period === 'q4_total') {
            const q4Total = monthsData[9] + monthsData[10] + monthsData[11]
            return this.valueRound(q4Total)
        }

        // Месяцы - прямое значение из массива
        if (period.startsWith('m')) {
            const monthIndex = parseInt(period.substring(1)) - 1  // m1 -> index 0, m2 -> index 1, etc.
            if (monthIndex >= 0 && monthIndex < 12) {
                return this.valueRound(monthsData[monthIndex])
            }
        }

        return ""
    }

    private initializeKbkExpanded() {
        // Инициализация is_expanded для всех КБК (по умолчанию развернуты)
        if (this.tableData.template4_items_structured_dspk) {
            this.tableData.template4_items_structured_dspk.forEach(dspk => {
                if (!('is_expanded' in dspk)) {
                    this.$set(dspk, 'is_expanded', true)
                }
            })
        }
    }

    private toggleKbkExpand(dspk_item: any) {
        // Переключение развернутости КБК
        this.$set(dspk_item, 'is_expanded', !dspk_item.is_expanded)
    }

    private getKbkRowStyle(dspk_item: any) {
        // Стили для строки КБК в зависимости от уровня
        // Подкласс (6 цифр типа 101100) - светлый фон
        // Специфика (6 цифр типа 101111) - более темный фон
        const code = dspk_item.code

        // Проверяем является ли это подклассом (последние 2 цифры = 00)
        if (code.length === 6 && code.endsWith('00')) {
            return 'background-color: #d0e8f0; font-weight: bold;'
        } else {
            return 'background-color: #e8f4f8; font-weight: bold;'
        }
    }

    private getActuallyRegionalLabel() {
        // Получить правильный текст "Собственно областной" или "Собственно районный"
        if (this.regionsList && this.regionsList.length > 0) {
            const region = this.regionsList[0].value
            // XX0000 - область -> "Собственно областной"
            // XXXX00 - район -> "Собственно районный"
            if (region.endsWith('0000')) {
                return 'Собственно областной'
            } else if (region.endsWith('00')) {
                return 'Собственно районный'
            }
        }
        return 'Собственно областной'
    }

}
